import React from "react";
import PropTypes from "prop-types";
import { Sticky } from "react-sticky";
import { focusedDocumentType } from "custom-prop-types";
import FaArrow from "react-icons/fa/long-arrow-up";
import styles from "components/documents/document-viewer.scss";
import { DraggableModal } from "components/common/modal";
import { Button } from "components/common/button";

export const RenderedDocument = (props) => {
  if (!props.isDraggable) {
    return (
      <Sticky stickyStyle={ { top: "150px" } } topOffset={ -200 }>
        <Document { ...props } />
      </Sticky>
    );
  }
  return <Document { ...props } />;
};

RenderedDocument.propTypes = {
  isDraggable: PropTypes.bool.isRequired
};

const Document = ({
  focusedDocument,
  isDraggable,
  onEndDraggableMode,
  onHideDocumentViewer,
  onStartDraggableMode
}) => (
  <DraggableModal handle={ ".toolbar" } isDisabled={ !isDraggable } isVisible>
    <div className={ styles["draggable-container"] }>
      <div className={ `${styles.toolbar} toolbar ${draggableClass(isDraggable)}` }>
        <span className={ styles["toolbar-buttons"] }>
          <Button onClick={ isDraggable ? onEndDraggableMode : onStartDraggableMode }>
            <FaArrow className={ isDraggable ? styles["right-arrow"] : styles["left-arrow"] } size={ 15 } />
          </Button>
          <span className={ `${styles.close} ${styles["close-document"]}` } onClick={ onHideDocumentViewer }>+</span>
        </span>
        <iframe className={ isDraggable ? styles.resizeable : styles.framer } src={ focusedDocument.attachment.url } />
      </div>
    </div>
  </DraggableModal>
);

Document.propTypes = {
  focusedDocument: focusedDocumentType.isRequired,
  isDraggable: PropTypes.bool.isRequired,
  onEndDraggableMode: PropTypes.func.isRequired,
  onHideDocumentViewer: PropTypes.func.isRequired,
  onStartDraggableMode: PropTypes.func.isRequired
};

const draggableClass = (isDraggable) => {
  if (isDraggable) {
    return styles["draggable-toolbar"];
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/js/components/documents/documents-grid/rendered-document.jsx